import { render } from "./LogoWall.vue?vue&type=template&id=194b6b98&ts=true"
import script from "./LogoWall.vue?vue&type=script&lang=ts"
export * from "./LogoWall.vue?vue&type=script&lang=ts"

import "./LogoWall.vue?vue&type=style&index=0&id=194b6b98&lang=scss"

import exportComponent from "/home/runner/work/digital-creative-website/digital-creative-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__